import HomeIndicator from "./HomeIndicator";
import PropTypes from "prop-types";

const FrameComponent5 = ({ className = "" }) => {
  return (
    <div
      className={`self-stretch flex flex-col items-start justify-start gap-5 text-center text-base text-light-text font-text-regular-lowercase ${className}`}
    >
      <textarea
        className="[border:none] bg-[transparent] h-40 w-auto [outline:none] self-stretch flex flex-row items-start justify-start pt-7 px-[69px] pb-[25px] box-border font-text-regular-lowercase text-base text-dark-text"
        placeholder="Người Việt Nam"
        rows={8}
        cols={20}
      />
      <div className="self-stretch flex flex-col items-start justify-start">
        <div className="self-stretch flex flex-col items-start justify-start">
          <textarea
            className="[border:none] bg-[transparent] h-40 w-auto [outline:none] self-stretch flex flex-row items-start justify-start pt-7 px-[69px] pb-[25px] box-border font-text-regular-lowercase text-base text-dark-text"
            placeholder="Người Việt Nam"
            rows={8}
            cols={20}
          />
          <HomeIndicator
            homeIndicatorBackgroundColor="#fff"
            homeIndicatorMargin="unset"
            homeIndicatorPosition="relative"
            homeIndicatorRight="unset"
            homeIndicatorBottom="unset"
            homeIndicatorLeft="unset"
            homeIndicatorTop="unset"
            homeIndicatorMarginTop="-11px"
          />
        </div>
        <div className="self-stretch flex flex-row items-start justify-start py-0 pl-[90px] pr-[100px] mt-[-3px] relative">
          <div className="relative font-medium whitespace-pre-wrap">
            + Thêm tài khoàn giao dịch mới
          </div>
        </div>
      </div>
    </div>
  );
};

FrameComponent5.propTypes = {
  className: PropTypes.string,
};

export default FrameComponent5;
